/* ==========================================================================
   Mix & Match — Scroll Story

   Le script fait trois choses, rien de plus :
   1. décider du mode d'affichage (flat ou scroll) ;
   2. pendant le scroll, écrire la progression dans des variables CSS et
      l'étape courante dans data-step ;
   3. synchroniser le double choix (team + format) et ajouter le duo
      Algérienne + partenaire au panier.

   Toutes les transformations visuelles sont dans la feuille de style.
   ========================================================================== */

(function () {
  'use strict';

  if (window.MixMatchStory) return;

  var ROOT_SELECTOR = '[data-mms-root]';
  var instances = new Map();

  /* Bornes de chaque étape sur la progression globale (0 → 1). */
  var STEPS = [
    { name: 'intro', start: 0, end: 0.11 },
    { name: 'split', start: 0.11, end: 0.24 },
    { name: 'worlds', start: 0.24, end: 0.42 },
    { name: 'cup', start: 0.42, end: 0.58 },
    { name: 'story', start: 0.58, end: 0.78 },
    { name: 'reveal', start: 0.78, end: 1 }
  ];

  function clamp01(value) {
    if (value < 0) return 0;
    if (value > 1) return 1;
    return value;
  }

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  function cartAddUrl() {
    var themeRoutes = window.theme && window.theme.routes;
    if (themeRoutes && themeRoutes.cart_add_url) return themeRoutes.cart_add_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart/add.js';
  }

  function cartUrl() {
    var themeRoutes = window.theme && window.theme.routes;
    if (themeRoutes && themeRoutes.cart_url) return themeRoutes.cart_url;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root + 'cart';
  }

  /* Le thème expose en général Shopify.formatMoney + Shopify.money_format ;
     à défaut, on retombe sur le format visible partout ailleurs sur le site
     (virgule décimale, symbole après le montant). */
  function formatMoney(cents) {
    if (
      window.Shopify &&
      typeof window.Shopify.formatMoney === 'function' &&
      window.Shopify.money_format
    ) {
      try {
        return window.Shopify.formatMoney(cents, window.Shopify.money_format);
      } catch (e) {
        /* on retombe sur le format par défaut ci-dessous */
      }
    }
    /* Format de la boutique posé par Liquid (data-money-format), pour écrire
       les prix exactement comme le filtre | money (ex. « €7,70 »). */
    var holder = document.querySelector('[data-money-format]');
    var format = holder ? holder.getAttribute('data-money-format') : '';
    var match = format && format.match(/\{\{\s*(\w+)\s*\}\}/);
    if (match) {
      var value = cents / 100;
      var parts = value.toFixed(2).split('.');
      var withSep = function (thousands, decimal) {
        return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + decimal + parts[1];
      };
      var amount;
      switch (match[1]) {
        case 'amount_with_comma_separator':
          amount = withSep('.', ',');
          break;
        case 'amount_no_decimals':
          amount = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          amount = Math.round(value).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
          break;
        case 'amount_with_apostrophe_separator':
          amount = withSep("'", '.');
          break;
        default:
          amount = withSep(',', '.');
      }
      return format.replace(match[0], amount);
    }
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ------------------------------------------------------------------ */
  /* Instance                                                            */
  /* ------------------------------------------------------------------ */

  function Instance(root) {
    this.root = root;
    this.track = root.querySelector('[data-mms-track]');
    this.stage = root.querySelector('[data-mms-stage]');
    this.video = root.querySelector('[data-mms-video]');
    this.status = root.querySelector('[data-mms-status]');
    this.revealPanel = root.querySelector('[data-mms-panel="reveal"]');
    this.form = root.querySelector('[data-mms-form]');
    this.stickyBar = root.querySelector('[data-mms-sticky-atc]');
    this.stickyButton = root.querySelector('[data-mms-sticky-submit]');
    this.stickyLabel = root.querySelector('[data-mms-sticky-label]');

    this.written = {};
    this.step = null;
    this.visible = false;
    this.ticking = false;
    this.submitting = false;
    this.listeners = [];

    this.onScroll = this.requestUpdate.bind(this);
    this.onResize = this.requestUpdate.bind(this);

    this.setMode();
    this.bind();
    this.observeStickyAtc();
    this.bindDuel();
    this.bindArrows();
    this.observePromotionView();

    if (this.mode === 'scroll') {
      this.observe();
      this.update();
    }
  }

  Instance.prototype.setMode = function () {
    var wantsSticky = this.root.getAttribute('data-mms-sticky') === 'true';
    var wantsAnimation = this.root.getAttribute('data-mms-animate') === 'true';
    var supported =
      'IntersectionObserver' in window &&
      typeof window.CSS !== 'undefined' &&
      typeof window.CSS.supports === 'function' &&
      window.CSS.supports('position', 'sticky');

    this.mode = wantsSticky && wantsAnimation && supported && !prefersReducedMotion() ? 'scroll' : 'flat';
    this.root.setAttribute('data-mms-mode', this.mode);
  };

  Instance.prototype.on = function (target, type, handler, options) {
    target.addEventListener(type, handler, options);
    this.listeners.push([target, type, handler, options]);
  };

  Instance.prototype.observe = function () {
    var self = this;

    /* Hors écran, on ne calcule plus rien. */
    this.observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          self.visible = entry.isIntersecting;
          if (self.visible) self.requestUpdate();
        });
      },
      { rootMargin: '10% 0px' }
    );
    this.observer.observe(this.root);

    this.on(window, 'scroll', this.onScroll, { passive: true });
    this.on(window, 'resize', this.onResize, { passive: true });
  };

  /* Barre d'ajout persistante (mobile) : visible dès que le CTA principal est
     sorti de l'écran, une fois qu'il a été vu au moins une fois. En mode
     scroll, le CTA n'est géométriquement hors-champ qu'une fois toute la
     scène pinnée dépassée — ce qui suppose déjà d'avoir défilé jusqu'au
     reveal. La visibilité réelle (CSS) importe peu à IntersectionObserver :
     seule la géométrie compte, ce qui est ici exactement ce qu'on veut. */
  Instance.prototype.observeStickyAtc = function () {
    if (!this.stickyBar || !('IntersectionObserver' in window)) return;

    var ctaEl = this.form && this.form.querySelector('[data-mms-submit]');
    if (!ctaEl) return;

    var self = this;
    var seen = false;

    this.stickyObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) seen = true;
          self.stickyBar.classList.toggle('is-visible', seen && !entry.isIntersecting);
        });
      },
      { threshold: 0.2 }
    );
    this.stickyObserver.observe(ctaEl);

    if (this.stickyButton) {
      this.on(this.stickyButton, 'click', function () {
        if (!self.form) return;
        if (typeof self.form.requestSubmit === 'function') {
          self.form.requestSubmit();
        } else {
          self.form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
        }
      });
    }
  };

  /* Double choix : l'état tient en deux valeurs, la team (original / spicy)
     et le format (500 / 950). Chaque carte team porte, pour chaque format,
     les IDs des deux variantes (Algérienne + partenaire), le prix cumulé, le
     prix barré cumulé et la disponibilité — rendus par Liquid. Tout le reste
     (champs du panier, prix, CTA, barre mobile, bouteilles, mise en scène)
     se recalcule depuis cet état. */
  Instance.prototype.bindDuel = function () {
    var duel = this.root.querySelector('[data-mms-duel]');
    if (!duel || !this.form) return;

    var teams = duel.querySelectorAll('[data-mms-team]');
    if (!teams.length) return;

    var form = this.form;
    var group = duel.querySelector('[data-mms-teams]');
    var formats = duel.querySelectorAll('[data-mms-size-option]');
    var formatBottles = duel.querySelectorAll('[data-mms-format-bottle]');

    var baseIdInput = form.querySelector('input[name="items[0][id]"]');
    var partnerIdInput = form.querySelector('input[name="items[1][id]"]');
    var handleInputs = form.querySelectorAll('input[name$="[properties][_mix_match]"]');
    var sizeInputs = form.querySelectorAll('input[name$="[properties][_size]"]');
    var submitButton = form.querySelector('[data-mms-submit]');
    var ctaLabel = form.querySelector('[data-mms-cta-label]');
    var ctaLabelBase = form.dataset.ctaLabelBase || '';

    var priceWas = duel.querySelector('.mix-match-story__hero-price-was');
    var priceNow = duel.querySelector('.mix-match-story__hero-price-now');
    var priceBadge = duel.querySelector('.mix-match-story__hero-badge');

    var stickyPrice = this.stickyBar ? this.stickyBar.querySelector('.mix-match-story__sticky-atc-price') : null;
    var stickyWas = stickyPrice ? stickyPrice.querySelector('s') : null;
    var stickyNow = stickyPrice ? stickyPrice.querySelector('strong') : null;
    var stickyDuo = this.stickyBar ? this.stickyBar.querySelector('[data-mms-sticky-duo]') : null;

    var self = this;
    var state = {
      team: duel.getAttribute('data-team'),
      format: duel.getAttribute('data-format')
    };

    function teamButton(name) {
      for (var i = 0; i < teams.length; i++) {
        if (teams[i].getAttribute('data-mms-team') === name) return teams[i];
      }
      return null;
    }

    function combo(button, format) {
      return {
        base: button.getAttribute('data-base-' + format) || '',
        partner: button.getAttribute('data-partner-' + format) || '',
        price: Number(button.getAttribute('data-price-' + format) || 0),
        compare: Number(button.getAttribute('data-compare-' + format) || 0),
        available: button.getAttribute('data-available-' + format) === 'true',
        bundle: button.getAttribute('data-bundle-' + format) || ''
      };
    }

    var savingsLine = duel.querySelector('[data-mms-savings]');
    var savingsTemplate = savingsLine ? savingsLine.getAttribute('data-template') || '' : '';

    function setPrice(nowEl, wasEl, price, compare) {
      if (nowEl) {
        nowEl.hidden = price <= 0;
        nowEl.textContent = price > 0 ? formatMoney(price) : '';
      }
      if (wasEl) {
        wasEl.hidden = compare <= price;
        wasEl.textContent = compare > price ? formatMoney(compare) : '';
      }
    }

    function render() {
      var button = teamButton(state.team);
      if (!button || button.disabled) {
        button = Array.prototype.filter.call(teams, function (btn) {
          return !btn.disabled;
        })[0] || teams[0];
      }
      state.team = button.getAttribute('data-mms-team');

      /* Format épuisé pour cette team : on bascule sur l'autre s'il est dispo. */
      var current = combo(button, state.format);
      if (!current.available) {
        var other = state.format === '500' ? '950' : '500';
        var fallback = combo(button, other);
        if (fallback.available) {
          state.format = other;
          current = fallback;
        }
      }

      var handle = button.getAttribute('data-handle') || '';
      var size = state.format + ' ml';

      /* Produit Mix & Match (prix de l'offre) s'il existe, sinon les deux sauces */
      if (baseIdInput) baseIdInput.value = current.bundle || current.base;
      if (partnerIdInput) partnerIdInput.value = current.bundle ? '' : current.partner;
      self.selection = {
        team: state.team,
        format: state.format,
        pair: button.getAttribute('data-pair') || '',
        handle: button.getAttribute('data-handle') || '',
        price: current.price,
        ids: current.bundle ? [current.bundle] : [current.base, current.partner]
      };
      Array.prototype.forEach.call(handleInputs, function (input) {
        input.value = handle;
      });
      Array.prototype.forEach.call(sizeInputs, function (input) {
        input.value = size;
      });

      duel.setAttribute('data-team', state.team);
      duel.setAttribute('data-format', state.format);

      Array.prototype.forEach.call(teams, function (btn) {
        var active = btn === button;
        btn.setAttribute('aria-checked', active ? 'true' : 'false');
        btn.setAttribute('tabindex', active ? '0' : '-1');
      });

      /* Formats : prix de chaque format pour la team choisie + étiquette
         « meilleure affaire » sur la plus forte remise en %. */
      var bestFormat = '';
      var bestPct = 0;
      Array.prototype.forEach.call(formats, function (btn) {
        var c = combo(button, btn.getAttribute('data-format'));
        var pct = c.compare > c.price && c.price > 0 ? (c.compare - c.price) / c.compare : 0;
        if (pct > bestPct + 0.001) {
          bestPct = pct;
          bestFormat = btn.getAttribute('data-format');
        }
      });
      var pcts = Array.prototype.map.call(formats, function (btn) {
        var c = combo(button, btn.getAttribute('data-format'));
        return c.compare > c.price && c.price > 0 ? Math.round(((c.compare - c.price) / c.compare) * 100) : 0;
      });
      if (pcts.length > 1 && pcts[0] === pcts[1]) bestFormat = '';

      Array.prototype.forEach.call(formats, function (btn) {
        var format = btn.getAttribute('data-format');
        var c = combo(button, format);
        var active = format === state.format;
        btn.classList.toggle('is-selected', active);
        btn.setAttribute('aria-pressed', active ? 'true' : 'false');
        btn.disabled = !c.available;
        var priceEl = btn.querySelector('[data-mms-size-price]');
        if (priceEl) priceEl.textContent = c.price > 0 ? formatMoney(c.price) : '';
        var bestEl = btn.querySelector('[data-mms-size-best]');
        if (bestEl) bestEl.hidden = format !== bestFormat;
      });

      if (savingsLine) {
        var saved = current.compare - current.price;
        savingsLine.hidden = !(saved > 0 && savingsTemplate);
        if (saved > 0 && savingsTemplate) {
          savingsLine.textContent = savingsTemplate
            .replace('[economie]', formatMoney(saved))
            .replace('[prix_barre]', formatMoney(current.compare));
        }
      }

      Array.prototype.forEach.call(formatBottles, function (bottle) {
        bottle.hidden = bottle.getAttribute('data-mms-format-bottle') !== state.format;
      });

      setPrice(priceNow, priceWas, current.price, current.compare);
      setPrice(stickyNow, stickyWas, current.price, current.compare);
      if (priceBadge) {
        var hasDiscount = current.compare > current.price;
        priceBadge.hidden = !hasDiscount;
        if (hasDiscount) {
          var percent = Math.round(((current.compare - current.price) / current.compare) * 100);
          priceBadge.textContent = '−' + percent + '%';
        }
      }
      if (stickyDuo) stickyDuo.textContent = button.getAttribute('data-pair') || '';

      if (!self.submitting) {
        if (ctaLabel) {
          ctaLabel.textContent =
            current.price > 0 ? ctaLabelBase + ' — ' + formatMoney(current.price) : ctaLabelBase;
        }
        if (submitButton) submitButton.disabled = !current.available;
        if (self.stickyButton) self.stickyButton.disabled = !current.available;
      }
    }

    function selectTeam(name, focus, viaHover) {
      var button = teamButton(name);
      if (!button || button.disabled || self.submitting) return;
      if (name === state.team && !focus) return;
      state.team = name;
      render();
      if (focus) button.focus();
      /* le survol seul n'est pas un choix : pas d'événement */
      if (!viaHover) self.trackPromotion('select_promotion');
    }

    this.on(duel, 'click', function (event) {
      if (!event.target.closest) return;

      var team = event.target.closest('[data-mms-team]') || event.target.closest('[data-mms-pick]');
      if (team) {
        selectTeam(team.getAttribute('data-mms-team') || team.getAttribute('data-mms-pick'));
        return;
      }

      var size = event.target.closest('[data-mms-size-option]');
      if (size && !size.disabled && !self.submitting) {
        state.format = size.getAttribute('data-format');
        render();
      }
    });

    /* Souris : le simple survol d'une carte, d'une bouteille latérale ou d'une
       cup choisit la team (le clic reste nécessaire au tactile). */
    this.on(duel, 'pointerover', function (event) {
      if (event.pointerType !== 'mouse' || !event.target.closest) return;
      var team = event.target.closest('[data-mms-team]') || event.target.closest('[data-mms-pick]');
      if (team) selectTeam(team.getAttribute('data-mms-team') || team.getAttribute('data-mms-pick'), false, true);
    });

    /* Radiogroup ARIA : les flèches passent d'une team à l'autre. */
    if (group) {
      this.on(group, 'keydown', function (event) {
        var step = { ArrowLeft: -1, ArrowUp: -1, ArrowRight: 1, ArrowDown: 1 }[event.key];
        if (!step) return;
        event.preventDefault();

        var enabled = Array.prototype.filter.call(teams, function (btn) {
          return !btn.disabled;
        });
        if (enabled.length < 2) return;
        var index = enabled.indexOf(teamButton(state.team));
        var next = enabled[(index + step + enabled.length) % enabled.length];
        selectTeam(next.getAttribute('data-mms-team'), true);
      });
    }

    render();
  };

  /* Flèches dessinées « nom de team → bouton », comme sur l'affiche :
     - Team O.G : part sous le nom, descend et vient pointer le bouton ;
     - Team Spicy : part du bouton, fait une boucle et remonte vers le nom.
     Le tracé est recalculé d'après les positions réelles (desktop, mobile,
     chargement de la police, redimensionnement). Quand il n'y a pas la place
     sur le côté du bouton (mobile), la flèche arrive / part par le dessus. */
  Instance.prototype.bindArrows = function () {
    var duel = this.root.querySelector('[data-mms-duel]');
    var svg = duel ? duel.querySelector('[data-mms-arrows]') : null;
    if (!svg) return;

    function pt(x, y) {
      return x.toFixed(1) + ' ' + y.toFixed(1);
    }

    function arrowHead(end, from, size) {
      var angle = Math.atan2(end.y - from.y, end.x - from.x);
      var a1 = angle + Math.PI * 0.78;
      var a2 = angle - Math.PI * 0.78;
      return (
        'M' + pt(end.x + size * Math.cos(a1), end.y + size * Math.sin(a1)) +
        'L' + pt(end.x, end.y) +
        'L' + pt(end.x + size * Math.cos(a2), end.y + size * Math.sin(a2))
      );
    }

    function rect(el, box) {
      var r = el.getBoundingClientRect();
      return { x: r.left - box.left, y: r.top - box.top, w: r.width, h: r.height, right: r.right, left: r.left };
    }

    function draw() {
      var box = duel.getBoundingClientRect();
      if (!box.width || !box.height) return;
      var size = Math.max(8, Math.min(15, box.width / 90));

      ['original', 'spicy'].forEach(function (team) {
        var path = svg.querySelector('[data-arrow="' + team + '"]');
        var tagEl = duel.querySelector('.mix-match-story__duel-tag--' + team);
        var cardEl = duel.querySelector('.mix-match-story__team--' + team);
        if (!path) return;
        if (!tagEl || !cardEl) {
          path.removeAttribute('d');
          return;
        }

        var tag = rect(tagEl, box);
        var card = rect(cardEl, box);
        var d;
        var end;
        var ctrl;

        if (team === 'original') {
          var s = { x: tag.x + tag.w * 0.22, y: tag.y + tag.h + 6 };
          if (card.x - s.x > 30) {
            /* arrive sur le côté gauche du bouton */
            end = { x: card.x - 10, y: card.y + card.h * 0.5 };
            ctrl = { x: s.x + (end.x - s.x) * 0.3, y: end.y + 6 };
            d = 'M' + pt(s.x, s.y) + 'C' + pt(s.x - 10, s.y + (end.y - s.y) * 0.85) + ' ' + pt(ctrl.x, ctrl.y) + ' ' + pt(end.x, end.y);
          } else {
            /* arrive par le dessus du bouton */
            end = { x: card.x + card.w * 0.22, y: card.y - 8 };
            ctrl = { x: end.x - 14, y: end.y - 18 };
            d = 'M' + pt(s.x, s.y) + 'C' + pt(s.x - 8, s.y + (end.y - s.y) * 0.7) + ' ' + pt(ctrl.x, ctrl.y) + ' ' + pt(end.x, end.y);
          }
        } else {
          var start;
          if (window.innerWidth - card.right > 46) {
            /* part du côté droit du bouton */
            start = { x: card.x + card.w + 12, y: card.y + card.h * 0.55 };
          } else {
            /* part du dessus du bouton */
            start = { x: card.x + card.w * 0.8, y: card.y - 8 };
          }
          end = { x: tag.x + tag.w * 0.6, y: tag.y + tag.h + 8 };
          if (start.y - end.y < 70) {
            /* trop peu de hauteur (mobile) : simple courbe, sans boucle */
            ctrl = { x: end.x + 12, y: end.y + 10 };
            d = 'M' + pt(start.x, start.y) + 'C' + pt(start.x + 14, start.y - (start.y - end.y) * 0.5) + ' ' + pt(ctrl.x, ctrl.y) + ' ' + pt(end.x, end.y);
          } else {
            /* Tracé d'origine (boucle puis remontée vers le nom). La tige
               arrive par la gauche de la pointe : la pointe file vers le
               haut-droite, dans le sens du trait, comme sur l'affiche. */
            end = { x: Math.min(start.x + 30, tag.x + tag.w - 12), y: tag.y + tag.h + 10 };
            ctrl = { x: end.x - 12, y: end.y + Math.max(26, (start.y - end.y) * 0.45) };
            d =
              'M' + pt(start.x, start.y) +
              /* petite boucle */
              'C' + pt(start.x + 24, start.y + 14) + ' ' + pt(start.x + 38, start.y - 14) + ' ' + pt(start.x + 21, start.y - 22) +
              'C' + pt(start.x + 6, start.y - 28) + ' ' + pt(start.x + 2, start.y - 8) + ' ' + pt(start.x + 19, start.y - 6) +
              /* puis remonte vers le nom de team */
              'C' + pt(start.x + 34, start.y - 4) + ' ' + pt(ctrl.x, ctrl.y) + ' ' + pt(end.x, end.y);
          }
        }

        path.setAttribute('d', d + arrowHead(end, ctrl, size));
      });
    }

    var scheduled = false;
    function schedule() {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(function () {
        scheduled = false;
        draw();
      });
    }

    if ('ResizeObserver' in window) {
      this.arrowObserver = new ResizeObserver(schedule);
      this.arrowObserver.observe(duel);
    }
    this.on(window, 'resize', schedule, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(draw);
    draw();
  };

  /* ------------------------------------------------------------------ */
  /* Suivi — même principe que le slider (hero-diaporama.js) : événements */
  /* GA4 e-commerce poussés dans le dataLayer pour GTM.                   */
  /* ------------------------------------------------------------------ */

  Instance.prototype.pushDataLayer = function (payload) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  };

  Instance.prototype.promotionData = function () {
    var sel = this.selection || {};
    var data = this.root.dataset;
    return {
      promotion_id: data.promoId || 'mix-match',
      promotion_name: data.promoName || 'Mix & Match',
      creative_name: sel.pair || '',
      creative_slot: (data.source || 'homepage') + '_' + (sel.team || '') + '_' + (sel.format || '') + 'ml',
      location_id: 'mix_match_' + (data.source || 'homepage')
    };
  };

  Instance.prototype.trackPromotion = function (eventName) {
    var promo = this.promotionData();
    promo.items = [];
    this.pushDataLayer({ event: eventName, ecommerce: promo, mix_match_source: this.root.dataset.source || 'homepage' });
  };

  Instance.prototype.trackAddToCart = function () {
    var sel = this.selection || {};
    var promo = this.promotionData();
    var value = (sel.price || 0) / 100;
    this.pushDataLayer({
      event: 'add_to_cart',
      mix_match_source: this.root.dataset.source || 'homepage',
      ecommerce: {
        currency: this.root.dataset.currency || 'EUR',
        value: value,
        items: [
          {
            item_id: (sel.ids || []).join('+'),
            item_name: 'Mix & Match ' + (sel.pair || ''),
            item_variant: (sel.format || '') + ' ml',
            item_category: 'Mix & Match',
            price: value,
            quantity: 1,
            promotion_id: promo.promotion_id,
            promotion_name: promo.promotion_name,
            creative_name: promo.creative_name,
            creative_slot: promo.creative_slot
          }
        ]
      }
    });
  };

  /* Attribut de panier « Mix & Match » : visible dans le détail de la
     commande (Informations supplémentaires) pour compter les ventes issues
     de la section. Ne bloque jamais l'ajout au panier. */
  Instance.prototype.tagCart = function () {
    var sel = this.selection || {};
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var label = (sel.pair || '') + ' · ' + (sel.format || '') + ' ml · ' + (this.root.dataset.source || 'homepage');
    return fetch(root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ attributes: { 'Mix & Match': label } })
    }).catch(function () {});
  };

  /* view_promotion : une seule fois, quand l'écran du double choix est vu */
  Instance.prototype.observePromotionView = function () {
    var duel = this.root.querySelector('[data-mms-duel]');
    if (!duel || !('IntersectionObserver' in window)) return;
    var self = this;
    this.viewObserver = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || self.promotionViewed) return;
          if (self.mode === 'scroll' && self.step !== 'reveal') return;
          self.promotionViewed = true;
          self.trackPromotion('view_promotion');
        });
      },
      { threshold: 0.4 }
    );
    this.viewObserver.observe(duel);
  };

  Instance.prototype.requestUpdate = function () {
    if (this.ticking || !this.visible) return;
    this.ticking = true;

    var self = this;
    window.requestAnimationFrame(function () {
      self.ticking = false;
      self.update();
    });
  };

  Instance.prototype.update = function () {
    if (this.mode !== 'scroll' || !this.track || !this.stage) return;

    var scrollable = this.track.offsetHeight - this.stage.offsetHeight;
    if (scrollable <= 0) return;

    var progress = clamp01(-this.track.getBoundingClientRect().top / scrollable);
    this.write('--mms-p', progress);

    var current = STEPS[0].name;

    for (var i = 0; i < STEPS.length; i++) {
      var step = STEPS[i];
      var sub = clamp01((progress - step.start) / (step.end - step.start));
      this.write('--mms-p-' + step.name, sub);
      if (progress >= step.start) current = step.name;
    }

    if (current !== this.step) {
      this.step = current;
      this.root.setAttribute('data-step', current);
      if (current === 'reveal' && !this.promotionViewed && this.selection) {
        this.promotionViewed = true;
        this.trackPromotion('view_promotion');
      }
      this.toggleInteractive();
      this.toggleVideo();
    }
  };

  /* Une variable CSS n'est réécrite que si elle a bougé de façon perceptible. */
  Instance.prototype.write = function (name, value) {
    var rounded = Math.round(value * 1000) / 1000;
    if (this.written[name] === rounded) return;
    this.written[name] = rounded;
    this.root.style.setProperty(name, String(rounded));
  };

  /* Le panneau masqué ne doit pas piéger le focus clavier. */
  Instance.prototype.toggleInteractive = function () {
    if (this.revealPanel) this.revealPanel.toggleAttribute('data-mms-hidden', this.step !== 'reveal');
  };

  Instance.prototype.toggleVideo = function () {
    if (!this.video) return;

    if (this.step === 'cup' || this.step === 'story') {
      var playing = this.video.play();
      if (playing && typeof playing.catch === 'function') playing.catch(function () {});
    } else if (!this.video.paused) {
      this.video.pause();
    }
  };

  /* ------------------------------------------------------------------ */
  /* Ajout au panier                                                     */
  /* ------------------------------------------------------------------ */

  Instance.prototype.bind = function () {
    if (!this.form) return;

    var self = this;
    this.on(this.form, 'submit', function (event) {
      self.submit(event);
    });
  };

  function collectItems(form) {
    var items = [];
    var inputs = form.querySelectorAll('input[name^="items["]');
    var pattern = /^items\[(\d+)\]\[(\w+)\](?:\[([^\]]+)\])?$/;

    Array.prototype.forEach.call(inputs, function (input) {
      var match = pattern.exec(input.name);
      if (!match) return;

      var position = Number(match[1]);
      var key = match[2];
      var subKey = match[3];

      items[position] = items[position] || {};

      if (key === 'properties' && subKey) {
        items[position].properties = items[position].properties || {};
        items[position].properties[subKey] = input.value;
      } else if (key === 'id' || key === 'quantity') {
        items[position][key] = Number(input.value);
      }
    });

    return items.filter(function (item) {
      return item && item.id;
    });
  }

  Instance.prototype.setStatus = function (message, state) {
    if (!this.status) return;
    this.status.textContent = message || '';
    if (state) {
      this.status.setAttribute('data-state', state);
    } else {
      this.status.removeAttribute('data-state');
    }
  };

  /* Les deux CTA (hero + barre sticky) restent synchronisés : même état
     occupé/succès, pour qu'aucun des deux ne mente sur ce qui se passe. */
  Instance.prototype.setButtonsBusy = function (busy) {
    [this.mainButton, this.stickyButton].forEach(function (btn) {
      if (!btn) return;
      btn.disabled = busy;
      if (busy) {
        btn.setAttribute('aria-busy', 'true');
      } else {
        btn.removeAttribute('aria-busy');
      }
    });
  };

  Instance.prototype.setButtonsSuccess = function (isSuccess) {
    [this.mainButton, this.stickyButton].forEach(function (btn) {
      if (btn) btn.classList.toggle('is-success', isSuccess);
    });
  };

  Instance.prototype.setLabels = function (text) {
    if (this.mainLabel) this.mainLabel.textContent = text;
  };

  /* La barre sticky garde son propre libellé (prix inclus) : on ne le
     remplace que pendant les états occupé/succès, jamais autrement. */
  Instance.prototype.setStickyLabel = function (text) {
    if (this.stickyLabel) this.stickyLabel.textContent = text;
  };

  Instance.prototype.submit = function (event) {
    event.preventDefault();

    if (this.submitting) return;

    var form = this.form;
    var items = collectItems(form);
    if (!items.length) return;

    this.mainButton = form.querySelector('[data-mms-submit]');
    this.mainLabel = form.querySelector('[data-mms-cta-label]');

    var initialLabel = this.mainLabel ? this.mainLabel.textContent : '';
    var initialStickyLabel = this.stickyLabel ? this.stickyLabel.textContent : '';
    var settings = this.root.dataset;
    var self = this;

    this.submitting = true;
    this.setButtonsBusy(true);
    this.setLabels(settings.loadingLabel || initialLabel);
    this.setStickyLabel(settings.loadingLabel || initialStickyLabel);
    this.setStatus('', null);

    /* Le thème indique lui-même les sections à rafraîchir. */
    var sections = [];
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections: sections } })
    );

    fetch(cartAddUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items,
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) {
        return response.json().then(function (state) {
          if (!response.ok || state.status) {
            throw new Error(state.description || state.message || settings.errorMessage);
          }
          return state;
        });
      })
      .then(function (state) {
        self.trackAddToCart();
        return self.tagCart().then(function () {
          return self.refreshCart(state);
        });
      })
      .then(function (refreshed) {
        self.setStatus(settings.successMessage, 'success');

        /* Confirmation visible ~700 ms avant l'ouverture du panier : le temps
           que « ✓ Mix ajouté » soit lu, sans ralentir la conversion. */
        self.setButtonsBusy(false);
        self.setButtonsSuccess(true);
        self.setLabels(settings.successLabel || initialLabel);
        self.setStickyLabel(settings.successLabel || initialStickyLabel);

        window.setTimeout(function () {
          self.openCart(self.mainButton, refreshed);

          window.setTimeout(function () {
            self.setButtonsSuccess(false);
            self.setLabels(initialLabel);
            self.setStickyLabel(initialStickyLabel);
            self.submitting = false;
          }, 250);
        }, 650);
      })
      .catch(function (error) {
        self.setStatus(error.message || settings.errorMessage, 'error');
        self.setButtonsBusy(false);
        self.setLabels(initialLabel);
        self.setStickyLabel(initialStickyLabel);
        self.submitting = false;
      });
  };

  /* Résout à true seulement si le panier du thème a réellement été rafraîchi. */
  Instance.prototype.refreshCart = function (state) {
    var pubsub = window.theme && window.theme.pubsub;
    if (!pubsub || !pubsub.PUB_SUB_EVENTS || !pubsub.PUB_SUB_EVENTS.cartUpdate) return Promise.resolve(false);

    return fetch(cartUrl(), { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        cart.sections = state.sections;
        pubsub.publish(pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'mix-match-story', cart: cart });
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: state } }));
        return true;
      })
      .catch(function () {
        return false;
      });
  };

  /* Sans rafraîchissement, le drawer afficherait un panier périmé : on bascule
     alors sur la page panier. */
  Instance.prototype.openCart = function (activeElement, refreshed) {
    var drawer = document.querySelector('cart-drawer');

    if (refreshed && drawer && typeof drawer.show === 'function') {
      drawer.show(activeElement || null);
      return;
    }

    window.location.href = cartUrl();
  };

  /* ------------------------------------------------------------------ */
  /* Cycle de vie                                                        */
  /* ------------------------------------------------------------------ */

  Instance.prototype.destroy = function () {
    if (this.observer) this.observer.disconnect();
    if (this.stickyObserver) this.stickyObserver.disconnect();
    if (this.arrowObserver) this.arrowObserver.disconnect();
    if (this.viewObserver) this.viewObserver.disconnect();

    this.listeners.forEach(function (entry) {
      entry[0].removeEventListener(entry[1], entry[2], entry[3]);
    });
    this.listeners.length = 0;
  };

  function init(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var roots = [];

    if (context.matches && context.matches(ROOT_SELECTOR)) roots.push(context);
    Array.prototype.push.apply(roots, context.querySelectorAll(ROOT_SELECTOR));

    roots.forEach(function (root) {
      if (instances.has(root)) return;
      instances.set(root, new Instance(root));
    });
  }

  function destroy(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;

    instances.forEach(function (instance, root) {
      if (context !== document && context !== root && !context.contains(root)) return;
      instance.destroy();
      instances.delete(root);
    });
  }

  window.MixMatchStory = { init: init, destroy: destroy, instances: instances };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroy(event.target);
  });
})();
